module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_axios@0.18.0@axios/index.js
// module id = 23
// module chunks = 0